import { useState, useMemo, useEffect } from "react";

export default function Pagination({ totalRow, onPageChange }: { totalRow: number, onPageChange: (data: any) => void; }) {
    const [pageSize, setPageSize] = useState(10);
    const [pageNumber, setPageNumber] = useState(1);

    const totalPages = useMemo(() => Math.ceil(totalRow / pageSize), [totalRow, pageSize]);

    const windowStart = Math.floor((pageNumber - 1) / 3) * 3 + 1;
    const pageButtons = [windowStart, windowStart + 1, windowStart + 2].filter(
        (n) => n <= totalPages
    );

    const goToPage = (n: number) => {
        if (n < 1 || n > totalPages) return;
        setPageNumber(n);
    };

    useEffect(() => {
        onPageChange({ pageNumber, pageSize });

    }, [pageNumber, pageSize]);

    return (
        <div className="ws-12 newPagination mt">
            <div className="pagination-wrapper ws-12">

                <div className="ws-7 pull-right">
                    <button className="ml text-sl pull-right" onClick={() => goToPage(totalPages)}>Last</button>
                    <button className="ml text-sl pull-right" onClick={() => goToPage(pageNumber + 1)}>Next</button>

                    {windowStart + 3 <= totalPages && (
                        <button className="dots ml text-s pull-right" onClick={() => goToPage(windowStart + 3)}>
                            ...
                        </button>
                    )}

                    {pageButtons.sort((a, b) => b - a).map((num) => (
                        <button key={num} className={num === pageNumber ? "is-active ml text-s pull-right" : "ml text-s pull-right"} onClick={() => goToPage(num)} >
                            {num}
                        </button>
                    ))}

                    {windowStart > 1 && (
                        <button className="dots ml text-s pull-right" onClick={() => goToPage(windowStart - 1)}>
                            ...
                        </button>
                    )}

                    <button className="ml text-sl pull-right" onClick={() => goToPage(pageNumber - 1)}>Prev</button>
                    <button className="ml text-sl pull-right" onClick={() => goToPage(1)}>First</button>
                </div>

                <div className="ws-5">
                    <div className=" w-20" >
                        <select className="ml page-size" value={pageSize} onChange={(e) => { setPageSize(Number(e.target.value)); setPageNumber(1); }}  >
                            {[10, 20, 50, 100].map((size) => (
                                <option key={size} value={size}>
                                    {size}
                                </option>
                            ))}
                        </select>
                    </div>

                    <span className="page-info text-bold text-sl ws-7 mtl">
                        Showing page {pageNumber} of {totalPages} ({totalRow} Items)
                    </span>
                </div>



            </div>
        </div>
    );
}